import { render, staticRenderFns } from "./AddPartner.vue?vue&type=template&id=0542ecd4&scoped=true"
import script from "./AddPartner.vue?vue&type=script&lang=js"
export * from "./AddPartner.vue?vue&type=script&lang=js"
import style0 from "./AddPartner.vue?vue&type=style&index=0&id=0542ecd4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0542ecd4",
  null
  
)

export default component.exports